export default __webpack_public_path__ + "static/media/Aurora Zone.c8a23332.jpg";